import React from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

interface Props {
  employeeId: number
  managerId: number | null
  locationId: number | null
  teamIdsSignature?: string
  onChange: (description: string) => void
  hasAssignments: boolean
}

const useTrackEmployeeChanges = ({
  employeeId,
  managerId,
  locationId,
  teamIdsSignature = '',
  onChange,
  hasAssignments,
}: Props) => {
  const prevManagerId = React.useRef<number | null>(managerId)
  const prevLocationId = React.useRef<number | null>(locationId)
  const prevTeamIds = React.useRef<string>(teamIdsSignature)

  useUnsafeEffect(() => {
    if (!hasAssignments) return

    const managerChanged = prevManagerId.current !== managerId
    const locationChanged = prevLocationId.current !== locationId
    const teamsChanged = teamIdsSignature !== '' && prevTeamIds.current !== teamIdsSignature

    if (managerChanged && locationChanged) {
      onChange(
        i18n.t('finance.employee_dimensions_info.modals.alert.description.manager_and_location')
      )
    } else {
      if (managerChanged) {
        onChange(i18n.t('finance.employee_dimensions_info.modals.alert.description.manager'))
      }
      if (teamsChanged) {
        onChange(i18n.t('finance.employee_dimensions_info.modals.alert.description.teams'))
      }
      if (locationChanged) {
        onChange(i18n.t('finance.employee_dimensions_info.modals.alert.description.location'))
      }
    }

    prevManagerId.current = managerId
    prevLocationId.current = locationId
    prevTeamIds.current = teamIdsSignature
  }, [employeeId, managerId, locationId, teamIdsSignature, hasAssignments])
}

export default useTrackEmployeeChanges
